import { useNavigate } from 'react-router'
import { Button } from '../ui/shadcn/button'
import { useSidebarStore } from '@/stores/sidebarStore'
import useCheckDevice from '../modules/DeviceSupport'
import { CassiSquareIcon } from '../ui/icons/CassiSquareIcon'
import { EditIcon, MenuIcon } from '../ui/icons/icons-new'
import { BrandSwitcher } from '../brand/brand-switcher'

export function SidebarHeader() {
  const navigate = useNavigate()
  const isMobile = useCheckDevice()

  const { toggleSidebar, closeSidebar } = useSidebarStore()

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center justify-between">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            navigate('/')
          }}>
          <CassiSquareIcon width="26" height="26" />
        </Button>
        <Button size="icon" variant="ghost" onClick={toggleSidebar}>
          <MenuIcon width={26} height={26} color="var(--foreground)" />
        </Button>
      </div>

      <BrandSwitcher />

      <Button
        onClick={() => {
          if (isMobile) closeSidebar()
          navigate('/')
        }}>
        <EditIcon width={20} height={20} color="white" />
        New Post
      </Button>
    </div>
  )
}
